<template>
  <div class="c-personal-wrapper">
    <!-- filter -->
    <per-filter
      slot="filter"
      :operator-data="operatorData"
      :project-group-data="projectGroupData"
      @on-add="visible = true"
      @on-down="downExcel"
      @on-import="importExcel"
      @on-change="filterData"
    />

    <!-- table  -->
    <Viewport v-model="tableHeight">
      <el-table class="common-el-table-styles" :data="tableData" :height="tableHeight" v-loading="loading">
        <el-table-column
          v-for="(col, id) in tableColumns"
          :key="id"
          :prop="col.key"
          :label="col.title"
          :show-overflow-tooltip="col.overflow"
          :min-width="col.width"
          :align="col.align"
        >
          <template slot-scope="scope">
            <div v-if="col.key === 'control'" class="m-control">
              <Poptip confirm transfer title="您确认删除该设计KPI吗？" @on-ok="delClick(scope.row)">
                <el-button type="text">删除</el-button>
              </Poptip>
              <el-button type="text" @click="editClick(scope.row)">&ensp;修改</el-button>
            </div>
            <span v-else-if="col.key === 'androidStandard'">{{ scope.row[col.key] | toPercent }}</span>
            <span v-else-if="col.key === 'iosStandard'">{{ scope.row[col.key] | toPercent }}</span>
            <span v-else-if="col.key === 'updateTime'">{{ scope.row[col.key] | datetimeToSec }}</span>
            <span v-else>{{ scope.row[col.key] }}</span>
          </template>
        </el-table-column>
      </el-table>
      <Page
        show-total
        show-sizer
        show-elevator
        class="c-table-page pager"
        size="small"
        :total="total"
        :current.sync="pageIndex"
        :page-size="pageSize"
        :page-size-opts="[10, 20, 30, 40, 100]"
        @on-change="changePageIndex"
        @on-page-size-change="changePageSize"
      />
    </Viewport>

    <resulter
      v-model="resultModel"
      type="设计KPI"
      :add-total="added"
      :update-total="updated"
      :fail-total="failure"
      :table-data="success_d"
      @on-close="resultOk"
    />

    <Modal
      v-model="visible"
      :title="title"
      :width="520"
      :mask-closable="false"
      class-name="vertical-center-modal"
      @on-visible-change="bindGetData"
    >
      <div class="m-form">
        <Form :label-width="140">
          <FormItem label="月份" prop="month">
            <DatePicker
              v-model="performance.month"
              type="month"
              placement="bottom-end"
              placeholder="请选择月份"
              :disabled="editble"
              style="width: 180px"
              transfer
            />
          </FormItem>
          <FormItem label="设计人员" prop="designerId">
            <auto-complete
              v-model="performance.designerId"
              :data="operatorData"
              :disabled="editble"
              :popper-append-to-body="false"
              placeholder="请选择人员"
              @on-select="handleGame"
            />
          </FormItem>
          <FormItem label="P级" prop="level">
            <Select v-model="performance.level" :disabled="editble" placeholder="请选择P级" style="width: 180px">
              <Option :value="1" label="P1"></Option>
              <Option :value="2" label="P2"></Option>
              <Option :value="3" label="P3"></Option>
              <Option :value="4" label="P4"></Option>
              <Option :value="5" label="P5"></Option>
              <Option :value="6" label="P6"></Option>
              <Option :value="7" label="P7"></Option>
              <Option :value="8" label="P8"></Option>
              <Option :value="9" label="P9"></Option>
            </Select>
          </FormItem>
          <FormItem label="合格KPI" prop="oneLevelNum">
            <InputNumber v-model="performance.oneLevelNum" :min="0" :max="100000000" style="width: 180px" />
          </FormItem>
          <FormItem label="优秀KPI" prop="twoLevelNum">
            <InputNumber v-model="performance.twoLevelNum" :min="0" :max="100000000" style="width: 180px" />
          </FormItem>
          <FormItem label="卓越KPI" prop="threeLevelNum">
            <InputNumber v-model="performance.threeLevelNum" :min="0" :max="100000000" style="width: 180px" />
          </FormItem>
        </Form>
      </div>
      <template slot="footer">
        <div class="m-foot">
          <Button @click="visible = false">取消</Button>
          <Button type="primary" :loading="saving" @click="handleSubmit">
            <span v-if="saving">提交中...</span>
            <span v-else>确认</span>
          </Button>
        </div>
      </template>
    </Modal>
  </div>
</template>
<script>
import moment from 'moment'
import { isArray, isEmpty, timeout } from '@/common/js/utils'
import { HOST_API } from '@/api/config'
import PerFilter from './components/per-filter'
import Resulter from '@/components/export/result-dialog'
import AutoComplete from '@/components/autocomplete/autocomplete'
import tableMixin from '../designerkpi/mixin_table'
import tableColumns from '../data/performance_columns'

import {
  getPerformancePage,
  addPerformance,
  editPerformance,
  getPerformanceDetail,
  delPerformanceById,
  importPerformanceExcel
} from '@/api/team.model'
import { getSysProject, getSysMember } from '@/api/common.model'

export default {
  name: 'Performance',
  mixins: [tableMixin],
  components: { AutoComplete, Resulter, PerFilter },
  computed: {
    title() {
      return this.editble ? '修改设计KPI' : '新增设计KPI'
    }
  },
  data() {
    return {
      tableHeight: 330,
      columns: [],
      tableData: [],
      tableColumns: [],
      operatorData: [],
      projectGroupData: [],

      saving: null,
      visible: null,
      editble: null,
      performance: {
        oneLevelNum: 0,
        twoLevelNum: 0,
        threeLevelNum: 0
      },
      resultModel: null,
      success_d: [],
      added: 0,
      failure: 0,
      updated: 0
    }
  },
  methods: {
    bindGetData(val) {
      if (!val) {
        this.editble = val
        timeout(300).then(() => {
          this.performance = { month: '', designerId: '', level: '', oneLevelNum: 0, twoLevelNum: 0, threeLevelNum: 0 }
        })
      }
    },
    importExcel(file) {
      this.$Spin.show()
      importPerformanceExcel({ file }).then((data) => {
        this.$Spin.hide()
        if (data && isArray(data.list)) {
          this.resultModel = true
          this.added = data.addTotal
          this.failure = data.failTotal
          this.updated = data.updateTotal
          this.success_d = data.list.map((ret) => {
            return {
              row_line: Object.keys(ret)[0],
              msg: ret[Object.keys(ret)[0]]
            }
          })
        }
      })
    },
    downExcel() {
      window.open(`${HOST_API}/api/ptom/template/downTemplate?templateType=template_type_ptom_kpi`, '_blank')
    },
    resultOk() {
      this.resultModel = false
      this.pageIndex = 1
      this.getData()
    },
    delClick({ id }) {
      delPerformanceById({ id }).then((data) => {
        data && this.getData()
      })
    },
    editClick({ id }) {
      getPerformanceDetail({ id }).then((data) => {
        if (data) {
          const { month, designerId, level, oneLevelNum, twoLevelNum, threeLevelNum } = data
          this.performance = { id, month, designerId, level, oneLevelNum, twoLevelNum, threeLevelNum }
          this.visible = true
          this.editble = true
        }
      })
    },
    handleGame(meta) {
      this.$set(this.performance, 'designerId', meta.id)
    },
    handleSubmit() {
      const { id, month, designerId, level, oneLevelNum, twoLevelNum, threeLevelNum } = this.performance
      const paramMonth = isEmpty(month) ? month : moment(month).format('YYYY-MM')
      const callFn = (data) => {
        this.saving = false
        data && (this.visible = false)
        data && this.getData()
      }
      const err = () => {
        this.saving = false
      }
      // 判断整数/小数
      const isInteger = (n) => {
        return parseInt(n) === parseFloat(n)
      }
      // 判断小数位数
      const floatLength = (n) => {
        return n.toString().split('.')[1].length
      }
      if (isEmpty(paramMonth)) {
        this.$Message.error('月份不能为空！')
        return
      }
      if (isEmpty(designerId) || !designerId) {
        this.$Message.error('设计人员不能为空！')
        return
      }
      if (isEmpty(level)) {
        this.$Message.error('P级不能为空！')
        return
      }
      if (!oneLevelNum || !twoLevelNum || !threeLevelNum) {
        this.$Message.error('KPI值不能为空或小于等于 0 ！')
        return
      }
      if (oneLevelNum < 0 || twoLevelNum < 0 || threeLevelNum < 0) {
        this.$Message.error('KPI值不能为负数！')
        return
      }
      if (oneLevelNum > 10000000000 || twoLevelNum > 10000000000 || threeLevelNum > 10000000000) {
        this.$Message.error('KPI值不能超过十位数！')
        return
      }
      if (
        (!isInteger(oneLevelNum) && floatLength(oneLevelNum) > 2) ||
        (!isInteger(twoLevelNum) && floatLength(twoLevelNum) > 2) ||
        (!isInteger(threeLevelNum) && floatLength(threeLevelNum) > 2)
      ) {
        this.$Message.error('请输入两位小数以内的KPI值！')
        return
      }
      this.saving = true
      if (this.editble) editPerformance({ id, oneLevelNum, twoLevelNum, threeLevelNum }).then(callFn).catch(err)
      else addPerformance({ month: paramMonth, designerId, level, oneLevelNum, twoLevelNum, threeLevelNum }).then(callFn).catch(err)
    },
    getData(filter) {
      let params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      }
      if (filter) params = Object.assign(params, filter)
      else params = Object.assign(this.params, params)
      this.params = JSON.parse(JSON.stringify(params))
      this.loading = true
      getPerformancePage(params)
        .then((data) => {
          if (typeof data !== 'symbol') {
            this.loading = false
            if (!data) return
            const { list, page_info } = data
            if (isArray(list) && page_info) {
              const { total_number } = page_info
              this.tableColumns = tableColumns
              this.tableData = list
              this.total = total_number || 0
            } else {
              this.tableColumns = []
              this.tableData = []
              this.total = 0
            }
          }
        })
        .catch(() => {
          this.loading = false
          this.tableData = []
          this.tableColumns = []
          this.total = 0
        })
    },
    preloadData() {
      Promise.all([getSysProject(), getSysMember()]).then((data) => {
        const [projectGroupData, operatorData] = data
        isArray(operatorData) && (this.operatorData = operatorData)
        isArray(projectGroupData) && (this.projectGroupData = projectGroupData)
        isArray(projectGroupData) && this.getData({})
      })
    }
  },
  created() {
    this.preloadData()
  }
}
</script>
<style lang="scss" scoped>
.c-personal-wrapper {
  .c-table-page {
    padding: 5px 0;
    text-align: right;
  }
}
</style>
